<template>
  <div class="error-page">
    <div class="error-content">
      <div class="error-icon">
        <i class="ri-error-warning-line"></i>
      </div>
      <h1 class="error-code">404</h1>
      <h2 class="error-title">頁面不存在</h2>
      <p class="error-message">抱歉，您訪問的頁面不存在或已被移除。</p>
      <div class="error-actions">
        <button class="btn btn-primary" @click="goHome">
          <i class="ri-home-line"></i>
          返回首頁
        </button>
        <button class="btn btn-secondary" @click="goBack">
          <i class="ri-arrow-left-line"></i>
          返回上一頁
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import authService from '@/helpers/authservice/authService.js';

export default {
  name: 'NotFound',
  setup() {
    const router = useRouter();

    const goHome = () => {
      if (authService.isAuthenticated()) {
        const accountType = authService.getAccountType();
        if (accountType === 'system') {
          router.push('/system/dashboard');
        } else if (accountType === 'platform') {
          router.push('/platform/dashboard');
        } else if (accountType === 'client') {
          router.push('/client/dashboard');
        }
      } else {
        router.push('/system/login');
      }
    };

    const goBack = () => {
      if (window.history.length > 1) {
        router.go(-1);
      } else {
        goHome();
      }
    };

    return {
      goHome,
      goBack,
    };
  },
};
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  padding: 20px;
}

.error-content {
  text-align: center;
  max-width: 500px;
}

.error-icon {
  font-size: 80px;
  color: #667eea;
  margin-bottom: 20px;
}

.error-icon i {
  display: block;
}

.error-code {
  font-size: 120px;
  font-weight: 700;
  color: #667eea;
  margin: 0;
  line-height: 1;
}

.error-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin: 20px 0 12px;
}

.error-message {
  font-size: 16px;
  color: #666;
  margin-bottom: 32px;
}

.error-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
}
</style>
